import { motion } from "framer-motion";
import { memo } from "react";
const ThreeColorOpacity = memo(
  ({ color, color2, color3, animationDuration }) => {
    return (
      <motion.div
        style={{
          backgroundColor: color,
          display: "flex",
          position: "absolute",
          inset: 0,
        }}
        animate={{
          backgroundColor: [
            "rgba(0,0,0,0)",
            color,
            "rgba(0,0,0,0)",
            color2,
            "rgba(0,0,0,0)",
            color3,
            "rgba(0,0,0,0)",
          ],
        }}
        transition={{
          duration: animationDuration,
          repeat: Infinity,
        }}
      ></motion.div>
    );
  }
);
export default ThreeColorOpacity;
